import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-hierarchy-widget',
  templateUrl: './hierarchy-widget.component.html',
  styleUrls: ['./hierarchy-widget.component.scss'],
})
export class HierarchyWidgetComponent {
  @Input() hierarchies: [] = [];
  @Output() imageEvent = new EventEmitter();
  @Output() promoteEvent = new EventEmitter();
  @Output() titleClickEvent = new EventEmitter();
  jsonStringify = JSON.stringify;

  constructor() {}

  addImageEvent(event, data) {
    this.imageEvent.emit(data);
  }

  emitPromoteEvent(event, data, nextData) {
    this.promoteEvent.emit({ currentData: data, nextData: nextData });
  }

  onTitleClick(data) {
    this.titleClickEvent.emit(data);
  }
}
